import { render, staticRenderFns } from "./ComboboxDesign.vue?vue&type=template&id=a3e5ed96&"
import script from "./ComboboxDesign.vue?vue&type=script&lang=ts&"
export * from "./ComboboxDesign.vue?vue&type=script&lang=ts&"
import style0 from "./ComboboxDesign.vue?vue&type=style&index=0&id=a3e5ed96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports